import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";
import type { BlockbrainCredentials } from "./getBlockbrainCredentials";

export async function saveBlockbrainCredentials(
  apiKey: string,
  apiUrl: string,
  botId: string,
): Promise<BlockbrainCredentials> {
  try {
    const data = await authenticatedFetchJson<BlockbrainCredentials>("/api/blockbrain-credentials", {
      method: "POST",
      body: JSON.stringify({ apiKey, apiUrl, botId }),
    });

    return {
      apiKey: data.apiKey || apiKey,
      apiUrl: data.apiUrl || apiUrl,
      botId: data.botId || botId,
    };
  } catch (error) {
    console.error("Error saving Blockbrain credentials:", error);
    throw error;
  }
}
